<div class="app-tool-box {{currentViewMode}}" [class.minimized]="isMinimized" [class.open]="!isMinimized"
	[class.visible]="!isProductBoxOpened">
	<div class="app-tool-box-header" (click)="handleState()">
		<i class="fa fa-angle-{{ isMinimized ? 'left': 'right' }}"></i>
	</div>
	<div class="app-tool-box-contents">
		<button class="open-btn" [disabled]="!currentPerimeter" (click)="accionHandleVisibility(true)">
			<span *ngIf="!isMinimized" class="label">
				{{ modelService.getString('builder_settings') }}</span>
			<i class="fa fa-gears fa-2x "></i>
		</button>
	</div>
</div>

<div *ngIf="currentPerimeter" class="card settingsWindow" [class.open]="isProductBoxOpened == true"
	[class.tab1]="currentTab === 0" [class.tab2]="currentTab === 1" [class.tab3]="currentTab === 2"
	[class.tab4]="currentTab === 3" [class.tab5]="currentTab === 99">
	<div class="card-header">
		<ul class="nav nav-tabs">
			<li *ngFor="let puerta of currentPerimeter.puertas; let i = index;" class="nav-item">
				<a class="nav-link" [class.active]="currentTab === 1 + i" [class.error]="!getCurrentDoor(i).idPuerta"
					[class.success]="getCurrentDoor(i).idPuerta" (click)="setCurrentTab(i + 1)">
					{{ modelService.getString('builder_door_title') }} #{{ i+1 }}
				</a>
			</li>
		</ul>
	</div>

	<button class="btn btnExit" (click)="accionHandleVisibility(false)"><i class="fa fa-sign-out"
			aria-hidden="true"></i></button>

	<div class="card-block scrollSettings">
		<app-product-picker #productPicker *ngIf="currentPerimeter" class="tab-product" [class.open]="true"
			[data]="getCurrentProduct()" [projectData]="projectData" [isDisabled]="isDisabled"
			(onChangeFamily)="OnChangeFamily($event)" (onSavePerimeter)="onSavePerimeter($event)"
			(onModeloSeleccionado)="setDoorPanelModel($event)" (onAlturaSeleccionada)="onAlturaSeleccionada($event)"
			(onPosteSeleccionado)="onPosteSeleccionado($event)" onTopEdgeCutSelected="onTopEdgeCutSeleccionado($event)"></app-product-picker>

		<app-door-picker #doorPicker *ngIf="getCurrentDoor(0)" class="tab-door" [class.open]="currentTab===1"
			[data]="getCurrentDoor(0)" [panel]="getCurrentProduct().panel" [product]="getCurrentProduct().modelo"
			[isDisabled]="isDisabled" (remove)="removeDoor(0)" [alturaPanel] = "alturaPanel">
		</app-door-picker>
		<app-door-picker #doorPicker *ngIf="getCurrentDoor(1)" class="tab-door" [class.open]="currentTab===2"
			[data]="getCurrentDoor(1)" [panel]="getCurrentProduct().panel" [product]="getCurrentProduct().modelo"
			[isDisabled]="isDisabled" (remove)="removeDoor(1)">
		</app-door-picker>
		<app-door-picker #doorPicker *ngIf="getCurrentDoor(2)" class="tab-door" [class.open]="currentTab===3"
			[data]="getCurrentDoor(2)" [panel]="getCurrentProduct().panel" [product]="getCurrentProduct().modelo"
			[isDisabled]="isDisabled" (remove)="removeDoor(2)">
		</app-door-picker>
		<app-door-picker #doorPicker *ngIf="getCurrentDoor(3)" class="tab-door" [class.open]="currentTab===4"
			[data]="getCurrentDoor(3)" [panel]="getCurrentProduct().panel" [product]="getCurrentProduct().modelo"
			[isDisabled]="isDisabled" (remove)="removeDoor(3)">
		</app-door-picker>
		<app-door-picker #doorPicker *ngIf="getCurrentDoor(4)" class="tab-door" [class.open]="currentTab===5"
			[data]="getCurrentDoor(4)" [panel]="getCurrentProduct().panel" [product]="getCurrentProduct().modelo"
			[isDisabled]="isDisabled" (remove)="removeDoor(4)">
		</app-door-picker>

		<!-- <app-terrain-info #terrainInfo class="" [isDisabled]="isDisabled" [class.open]="true" [canHaveWall]="wallAvailable" [data]="getCurrentInformation()"></app-terrain-info> -->
		<!-- app-terrain-info -->
		<div *ngIf="!actualModelo('LUX_ELECTRO')" class="row terrenoTitulo">
			<p class="Labels">{{ modelService.getString('conf_terreno') }}</p>
		</div>

		<div *ngIf="!actualModelo('LUX_ELECTRO')" class="row configuracion">

			<div *ngIf="wallAvailable" class="form-group col-sm-3" style="justify-content: flex-end;">
				<label style="font-size: 16px;" for="baseTypeSelector">
					{{ modelService.getString('builder_terrain_wall') }}
				</label>
				<select class="form-control" id="baseTypeSelector" [disabled]="isDisabled"
					[ngModel]="currentPerimeter.informacion.tieneMuro" (change)="onChangeWall($event);">
					<option [value]="false">{{ modelService.getString('builder_ground_no') }}</option>
					<option [value]="true">{{ modelService.getString('builder_ground_yes') }}</option>
				</select>
			</div>

			<div *ngIf="currentPerimeter.informacion.tieneMuro && wallAvailable" class="col-sm-3 form-group"
				style="justify-content: flex-end;">
				<label style="font-size: 16px;" for="baseTypeSelector">
					{{ modelService.getString('builder_terrain_wall_height') }}
				</label>
				<input id="altura-muro" type="number" min="0" max="300" (change)="onChangeHeightWall($event)"
					[disabled]="isDisabled" [ngModel]="currentPerimeter.informacion.alturaMuro">
			</div>

			<div *ngIf="currentPerimeter.informacion.tieneMuro" class="col-sm-3 form-group"
				style="justify-content: flex-end;">

				<label style="font-size: 16px;" for="baseTypeSelector">
					{{ modelService.getString('builder_terrain_wall_base') }}
				</label>

				<div class="form-check form-check-inline">
					<label class="form-check-label">
						<label class="radio-inline">
							<input name="placa-base" type="radio"
								[checked]="!currentPerimeter.informacion.tienePlacaBase"
								(change)="onChangeWallBase($event)">
							{{ modelService.getString('builder_base_no') }}
						</label>
					</label>
				</div>

				<div class="form-check form-check-inline">
					<label class="form-check-label">
						<label class="radio-inline">
							<input name="placa-base" type="radio"
								[checked]="currentPerimeter.informacion.tienePlacaBase"
								(change)="onChangeWallBase($event)">
							{{ modelService.getString('builder_base_yes') }}
						</label>
					</label>
				</div>

			</div>
		</div>

		<div class="input-group comentarioText">
			<div class="nombreComentario">
				<div class="" id="btnGroupCom">{{ modelService.getString('builder_terrain_comments') }}
				</div>
			</div>
			<textarea [disabled]="isDisabled" [(ngModel)]="currentPerimeter.informacion.comentarios"
				class="form-control" aria-describedby="btnGroupCom"></textarea>
		</div>

	</div>
</div>

<app-alert #alertWindow ></app-alert>